/**
 * keys.js — Sprint 1.5b
 *
 * Nessun salvataggio della mnemonica in chiaro. La mnemonica vive solo:
 *   - in memoria volatile (Zustand store) durante una sessione
 *   - cifrata via PIN in localStorage (Door A)
 *   - cifrata via PIN sul server Firestore (Door B)
 *
 * Questo modulo gestisce ESCLUSIVAMENTE wipe per eventuali residui di
 * versioni precedenti che usavano IDB.
 *
 * Le funzioni saveKeys/loadKeys restano come no-op per retro-compatibilita'.
 */

const DB_NAME = 'nullum';

/**
 * Cancella il database legacy IndexedDB. Sicuro chiamarla sempre.
 */
export async function wipeKeys() {
  try {
    await new Promise((res) => {
      const req = indexedDB.deleteDatabase(DB_NAME);
      req.onsuccess = () => res();
      req.onerror = () => res();
      req.onblocked = () => res();
    });
  } catch {}
}

/**
 * No-op (compat). Sprint 1.5b non persiste piu' la mnemonica in chiaro.
 */
export async function saveKeys(_keys) {
  return;
}

/**
 * Returns null sempre. La mnemonica chiara non e' piu' persistita.
 */
export async function loadKeys() {
  return null;
}

/**
 * Sempre false.
 */
export async function hasKeys() {
  return false;
}
